import { jsx as r, jsxs as l } from "react/jsx-runtime";
import g from "clsx";
import { useState as m, useEffect as x } from "react";
import a from "./Editable.module.css.js";
import { Popover as C } from "../Popover/Popover.js";
import { Input as j } from "../Input/Input.js";
import { Flex as I } from "../Flex/Flex.js";
import { IconButton as c } from "../IconButton/IconButton.js";
import { Close as N } from "../../foundations/icons/Close.js";
import { Selected as S } from "../../foundations/icons/Selected.js";
const q = ({
  value: e,
  placeholder: p,
  label: s,
  emptyText: n = "Empty",
  onChange: f,
  disabled: u = !1,
  className: d
}) => {
  const [t, i] = m(e), [h, y] = m(!1);
  x(() => {
    i(e);
  }, [e]);
  const b = (o) => {
    y(!t), t && (f(t), o(!1));
  };
  return /* @__PURE__ */ r(
    C,
    {
      placement: "top",
      withArrow: !0,
      content: (o) => /* @__PURE__ */ l("div", { className: g(a.container, d), children: [
        /* @__PURE__ */ r(
          j,
          {
            "aria-label": s,
            placeholder: p,
            value: t,
            error: h,
            onChange: (E) => {
              i(E.currentTarget.value);
            }
          }
        ),
        /* @__PURE__ */ l(I, { gap: 2, justify: "flex-end", children: [
          /* @__PURE__ */ r(c, { ariaLabel: "Cancel", appearance: "primary", onClick: () => o(!1), children: /* @__PURE__ */ r(N, {}) }),
          /* @__PURE__ */ r(
            c,
            {
              ariaLabel: "Save",
              appearance: "primary",
              onClick: () => b(o),
              disabled: u,
              children: /* @__PURE__ */ r(S, {})
            }
          )
        ] })
      ] }),
      children: /* @__PURE__ */ r("button", { type: "button", className: a.trigger, children: e || !!n && /* @__PURE__ */ r("span", { className: a.empty, children: n }) })
    }
  );
};
export {
  q as Editable
};
//# sourceMappingURL=Editable.js.map
